import { Component } from '@angular/core';
import { LoginHeaderService } from 'src/libs/state/login-header.service';

@Component({
  selector: 'fini-login-checkemail',
  templateUrl: './login-checkemail.component.html',
  styleUrl: './login-checkemail.component.scss',
  standalone: false
})
export class LoginCheckemailComponent {
  constructor(private header: LoginHeaderService) {
    // Push header data up the tree
    this.header.set({
      title: 'Confirmation',
      subtitle: 'We\'ve sent you a confirmation email',
    });
  }
}
